$(function() {

    var results = $('.site-search__results');
    var endpoint = '/search/auto';
    var trackingSent = false;

    $('.site-search__input').on('keyup', function(search) {
        // Trim the search
        var trimmedSearch = $(this).val().trim();

        // Close search if escape key pressed
        if (search.which == 27) {
            hideResults();
            return;
        }

        // If up or down don't search
        if (search.which != 40 && search.which != 38) {
            if (trimmedSearch.length >= 3) {
                // Tracking
                if (!trackingSent) {
                    if ('ga' in window) {
                        ga('send', 'event', 'Search', 'HomeAutocompleteType');
                    }
                    trackingSent = true;
                }
                getResults(trimmedSearch);
            } else {
                removeResults();
            }
        }
    });

    // Allow closing by clicking
    $('body.home').on('click', function(e) {
        current = $(e.target);

        if (current.hasClass('site-search__results')) {
            return;
        }

        if (current.parents('.site-search__results').length == 1) {
            return;
        }

        hideResults();
    });

    $('.site-search__input').on('click', function(search) {
        if (window.innerWidth > 550) {
            if ($('.site-search').hasClass('site-search--2')) {
                $('html, body').animate({
                    scrollTop: $(".home-hero__search").offset().top - ($('.navigation__header').innerHeight())
                }, 600);
            }

            if ($('.site-search').hasClass('site-search--1')) {
                var pos = $('.site-search__input').offset().top + 480;
                var height = window.innerHeight;

                if (pos > height) {
                    $('html, body').animate({
                        scrollTop: $(".site-search__input").offset().top - ($('.navigation__header').innerHeight())
                    }, 600);
                }
            }
        }

        if (!!search) {
            $('.site-search__input').trigger('keyup');
        }
    });

    var getResults = debounce(
        function(trimmedSearch) {
            $('.site-search__loading').show();

            $.ajax(endpoint, {
                type : 'GET',
                data : {
                    q: trimmedSearch
                },
                success: function(data) {
                    var rawResults = {};

                    results.empty();

                    $.each(data.payload, function(key, value) {
                        results.append('<div id="site-search__section_' + key + '" class="site-search__section"><svg class="icon-search site-search__icon"><use xlink:href="/images/svg-symbols.svg#' + value['image'] + '" /></svg><dt class="site-search__category">'
                            + key + '</dt></div>'
                        );

                        $.each(value['results'], function(index, item) {
                            $('#site-search__section_' + key).append('<dd class="site-search__result"><a href="' + item['url'] + '">' + item['title'] + '</a></dd>')
                        });
                    });

                    if (Object.keys(data.payload).length > 0) {
                        if (!$('.site-search__section').hasClass('site-search__show')) {
                            showResults();
                        }

                        $('.site-search__section').removeClass('site-search__show');

                        if (!results.hasClass('site-search__show')) {
                            showResults();
                        }
                        $('.site-search__section').show();

                        // Force repaint
                        if ($('.site-search__section').length > 0) {
                            $('.site-search__section')[0].offsetWidth;
                        }
                        // Animate and show
                        $('.site-search__section').addClass('site-search__show');

                    } else {
                        hideResults();
                    }

                    $('.site-search__loading').hide();
                }
            });
        },
        200
    );

    var removeResults = function() {
        if (results.hasClass('site-search__show')) {
            hideResults();
        }
    }

    var hideResults = function() {
        results.removeClass('site-search__show');
        window.setTimeout(function() {
            results.hide();
        },
        300);
    }

    var showResults = function() {
        results.show(10, function() {
            results.addClass('site-search__show');
        });
    }
});
